
export default function WhyFree() {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            為什麼可以0元？
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl p-10 md:p-14 shadow-lg border border-gray-100">
          <div className="space-y-6">
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              因為我們<strong className="text-teal-600">不是一次性交付的網站公司</strong>，<br />
              而是提供<strong className="text-gray-900">「網站持續管理與服務」</strong>的訂閱制模式。
            </p>
            
            <div className="h-px bg-gray-200 my-8"></div>
            
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              網站本身只是入口，<br />
              真正的價值在於<strong className="text-gray-900">後續是否有人負責、持續優化</strong>。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center p-6 bg-teal-50 rounded-xl">
              <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-refresh-line text-2xl text-white"></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">持續服務</h3>
              <p className="text-sm text-gray-600">不是做完就消失</p>
            </div>
            <div className="text-center p-6 bg-teal-50 rounded-xl">
              <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">專人負責</h3>
              <p className="text-sm text-gray-600">長期有人管理</p>
            </div>
            <div className="text-center p-6 bg-teal-50 rounded-xl">
              <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">持續優化</h3>
              <p className="text-sm text-gray-600">隨時可以升級</p>
            </div>
          </div>
        </div>

        {/* 新增費用說明區塊 */}
        <div className="mt-16">
          <div className="text-center mb-8">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              那你需要付什麼？
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed">
              天下沒有白吃的午餐，但我們保證這頓午餐很平價。<br />
              這些是維持一個網站在網路上存在的<strong className="text-gray-800">「硬成本」</strong>。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
            <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
              <div className="flex items-start">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-server-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">伺服器代管費</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    讓網站 24 小時運作的主機空間。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
              <div className="flex items-start">
                <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-global-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">網域年費</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    就是你的網址 (www.屬於您的.com)。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-10 md:p-12 text-white text-center shadow-lg">
            <div className="mb-6">
              <p className="text-lg opacity-90 mb-2">每月僅需</p>
              <div className="text-5xl md:text-6xl font-bold mb-2">
                NT$ 990
                <span className="text-2xl font-normal opacity-80 ml-2">/ 起</span>
              </div>
            </div>
            
            <p className="text-base md:text-lg opacity-95 mb-6 leading-relaxed">
              包含主機維護、SSL 安全憑證、技術支援。建置費 $0。
            </p>
            
            <a 
              href="/consultation"
              className="inline-block bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              立即諮詢方案
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
